import http from '@/utils/http' //引入axios
export const getAlipayTransaction = data => http.get('/kg-payment/api/alipay/transaction', {
    params: data
}) //查找Alipay交易记录
export const exportCord = data => http.get('/kg-payment/api/alipay/transaction/excel', {
    params: data,
    responseType: 'blob'
})
export default {
    getAlipayTransaction,
    exportCord
}